var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"createSuccess"},[_c('div',{staticClass:"success-icon"},[_c('Icon',{attrs:{"name":"passed","size":"100","color":"#07C160"}}),_c('h1',{staticClass:"success-text"},[_vm._v("Created successfully")])],1),_c('Button',{staticClass:"success-btn",on:{"click":_vm.goAccoundDetail}},[_vm._v("View Details")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }